module.exports = __webpack_public_path__ + "static/media/QUOTE4.e8ef4c89.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/QUOTE4.png
// module id = 276
// module chunks = 0